module.exports = __webpack_public_path__ + "img/lot-04.516d8040.webp";